const environment = import.meta.env.VITE_ENVIRONMENT;

const apiHosts = {
  production: 'https://api.smarthoa.io',
  staging: 'https://smarthoa-app-staging.onrender.com',
  local: 'http://localhost:3001'
};

export const baseURL = apiHosts[environment] || apiHosts.local;